'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var NutritionFacts = function NutritionFacts(props) {
  var product = props.product;
  return _react2.default.createElement('div', {
    className: 'nutrition-facts ' + props.className
  }, _react2.default.createElement('p', {
    className: 'nutrition-facts__serving'
  }, _react2.default.createElement('span', {
    className: 'nutrition-facts__serving-title'
  }, props.servingSize, ' '), _react2.default.createElement('span', {
    className: 'nutrition-facts__serving-size'
  }, product.product_info.serving_size, ' ', product.product_info.serving_units_code)), props.threeColumn ? _react2.default.createElement('table', {
    className: 'nutrition-table nutrition-table--3-column',
    'aria-label': product.name + ' Nutrition Facts'
  }, _react2.default.createElement('thead', {
    className: 'nutrition-table__head'
  }, _react2.default.createElement('tr', {
    className: 'nutrition-table__row'
  }, _react2.default.createElement('th', {
    className: 'nutrition-table__header'
  }), _react2.default.createElement('th', {
    className: 'nutrition-table__header'
  }, props.perServing), _react2.default.createElement('th', {
    className: 'nutrition-table__header'
  }, props.dailyValue))), _react2.default.createElement('tbody', {
    className: 'nutrition-table__body'
  }, Object.values(product.nutrition).map(function (fact, index) {
    if (fact.title && fact.value) {
      return _react2.default.createElement('tr', {
        className: 'nutrition-table__row',
        key: 'nutrition-facts-' + index // eslint-disable-line
      }, _react2.default.createElement('td', {
        className: 'nutrition-table__fact nutrition-table__fact--title'
      }, fact.title, props.factPunctuation, ' '), _react2.default.createElement('td', {
        className: 'nutrition-table__fact nutrition-table__fact--value'
      }, fact.value), _react2.default.createElement('td', {
        className: 'nutrition-table__fact ' + (fact.dv ? 'nutrition-table__fact--dv' : '')
      }, fact.dv));
    }
    return null;
  }))) : _react2.default.createElement('table', {
    className: 'nutrition-table',
    'aria-label': product.name + ' Nutrition Facts'
  }, _react2.default.createElement('thead', {
    className: 'nutrition-table__head'
  }, _react2.default.createElement('tr', {
    className: 'nutrition-table__row'
  }, _react2.default.createElement('th', {
    className: 'nutrition-table__header'
  }, props.perServing), _react2.default.createElement('th', {
    className: 'nutrition-table__header'
  }, props.dailyValue))), _react2.default.createElement('tbody', {
    className: 'nutrition-table__body'
  }, Object.values(product.nutrition).map(function (fact, index) {
    if (fact.title && fact.value) {
      return _react2.default.createElement('tr', {
        className: 'nutrition-table__row',
        key: 'nutrition-facts-' + index // eslint-disable-line
      }, _react2.default.createElement('td', {
        className: 'nutrition-table__fact'
      }, _react2.default.createElement('span', {
        className: 'nutrition-table__fact--title'
      }, fact.title, props.factPunctuation, ' '), _react2.default.createElement('span', {
        className: 'nutrition-table__fact--value'
      }, fact.value)), _react2.default.createElement('td', {
        className: 'nutrition-table__fact ' + (fact.dv ? 'nutrition-table__fact--dv' : '')
      }, fact.dv));
    }
    return null;
  }))), props.calorieSource ? _react2.default.createElement('p', {
    className: 'calorie-source'
  }, props.calorieSource) : null, _react2.default.createElement('p', {
    className: 'nutrition-facts__disclaimer'
  }, props.disclaimer), _react2.default.createElement('p', {
    className: 'nutrition-facts__ingredients'
  }, _react2.default.createElement('span', {
    className: 'nutrition-facts__ingredients-title'
  }, props.ingredients, ' '), _react2.default.createElement('span', {
    className: 'nutrition-facts__ingredients-list'
  }, product.ingredient.join(', '))));
};
NutritionFacts.defaultProps = {
  calorieSource: '',
  className: '',
  dailyValue: '% Daily Value',
  disclaimer: '*Percent Daily Values are based on 2,000 calorie diet.',
  factPunctuation: '',
  // eslint-disable-line
  ingredients: 'Ingredients',
  perServing: 'Per Serving',
  servingSize: 'Serving Size',
  threeColumn: false
};
NutritionFacts.propTypes = {
  calorieSource: _propTypes2.default.string,
  className: _propTypes2.default.string,
  dailyValue: _propTypes2.default.string,
  disclaimer: _propTypes2.default.string,
  factPunctuation: _propTypes2.default.string,
  // eslint-disable-line
  ingredients: _propTypes2.default.string,
  perServing: _propTypes2.default.string,
  product: _propTypes2.default.shape({
    ingredient: _propTypes2.default.array,
    nutrition: _propTypes2.default.shape({}),
    product_info: _propTypes2.default.shape({
      serving_size: _propTypes2.default.string,
      serving_units_code: _propTypes2.default.string
    })
  }).isRequired,
  servingSize: _propTypes2.default.string,
  threeColumn: _propTypes2.default.bool
};
exports.default = NutritionFacts;